import React, { useEffect, useState } from "react";

interface MenuItem {
    value: string;
    href: string;
    label: string;
    icon?: string;
    iconSvg?: boolean;
}

const MENU_ITEMS: MenuItem[] = [
    { value: "1", href: "/my-account", label: "Tài khoản của tôi", icon: "https://cdn-web-next.thuocsi.vn/images/infoTabsV2/user.svg" },
    { value: "3", href: "/my-order", label: "Đơn hàng của tôi", icon: "https://cdn-web-next.thuocsi.vn/images/infoTabsV2/myOrder.svg" },
    { value: "11", href: "/user/wishlist", label: "Sản phẩm quan tâm", icon: "https://cdn-web-next.thuocsi.vn/images/infoTabsV2/wishlist.svg" },
    { value: "8", href: "/users/loyalty_points", label: "Điểm tích luỹ", icon: "https://cdn-web-next.thuocsi.vn/images/infoTabsV2/points.svg" },
    // { value: "7", href: "/users/my-ticket", label: "Phản hồi của tôi", icon: "https://cdn-web-next.thuocsi.vn/images/infoTabsV2/feedback.svg" },
    // { value: "13", href: "/users/rewards", label: "Chương trình trả thưởng", icon: "https://cdn-web-next.thuocsi.vn/images/infoTabsV2/quest_rewards.svg" },
    //{ value: "9", href: "https://tracuu.thuocsi.vn", label: "Tra cứu vận đơn", icon: "https://cdn-web-next.thuocsi.vn/images/infoTabsV2/billoflading.svg" },
    // { value: "5", href: "/users/referrals", label: "Giới thiệu bạn bè", icon: "https://cdn-web-next.thuocsi.vn/images/infoTabsV2/referFriends.svg" },
    { value: "12", href: "/productviewed", label: "Sản phẩm đã xem", icon: "https://cdn-web-next.thuocsi.vn/images/infoTabsV2/viewed.svg" },
    { value: "15", href: "/history-purchased", label: "Sản phẩm đã mua", iconSvg: true },
    { value: "6", href: "/users/my-voucher", label: "Mã giảm giá của tôi", icon: "https://cdn-web-next.thuocsi.vn/images/infoTabsV2/voucher_icon.svg" },   
];

export default function AccountMenu() {
    const [activeHref, setActiveHref] = useState<string>("");

    // Active theo URL hiện tại
    useEffect(() => {
        if (typeof window !== "undefined") {
            setActiveHref(window.location.pathname);
        }
    }, []);

    return (
        <div className="styles_WrapSilder__YIO5V MuiBox-root css-0 hidden-1199">
            <div className="styles_wrapBox__A39vY MuiBox-root css-0">

                {MENU_ITEMS.map((item) => {
                    const isActive = activeHref === item.href;

                    return (
                        <div
                            key={item.value}
                            className={
                                "styles_wrapMenu__X8MKr MuiBox-root css-0 " +
                                (isActive
                                    ? "styles_tab_active__deufB"
                                    : "styles_tab_inactive__C1FuY")
                            }
                            onClick={() => setActiveHref(item.href)}
                        >
                            <a className="styles_mobile_rootBase__8z7PQ" href={item.href}>
                                <div className="styles_menuIcon__oZkHq MuiBox-root css-0">

                                    {/* icon dạng ảnh */}
                                    {!item.iconSvg && item.icon && (
                                        <img src={item.icon} alt="" />
                                    )}

                                    {/* icon dạng SVG đặc biệt */}
                                    {item.iconSvg && (
                                        <svg
                                            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium !text-[#0e1983] css-vubbuv"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"></path>
                                            <path d="M21 11.5 15.51 17l-3.01-3-1.5 1.5 4.51 4.5 6.99-7z"></path>
                                        </svg>
                                    )}
                                </div>

                                <div className="styles_menuLabel__zO5a4 MuiBox-root css-0">
                                    <p className="MuiTypography-root styles_titleTab__Hz1LR MuiTypography-body1">
                                        {item.label}
                                    </p>
                                </div>
                            </a>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
